import {
  AfterViewChecked,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output, SimpleChange,
  SimpleChanges
} from '@angular/core';
import { Evento } from '../../../../_models/evento';
import { UnidadEtapasService } from '../_services/unidad-etapas.service';
import { EventoUnidad } from '../../../../_models/evento-unidad';
import { EstudioService } from '../../estudio.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ComentariosService } from '../../../../_components/glm-comentarios/comentarios.service';
import { GapiPickerService } from '../../../../_services/gapi-picker';
import { Subscription } from 'rxjs';
import { CustomAlertService } from '../../../../_components/custom-alert/custom-alert.service';
import { ActivatedRoute, Event, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { RetroalimentacionService } from '../../retroalimentacion/_services/retroalimentacion.service';
import * as moment from 'moment';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_FORMATS } from '../../../../_models/moment-formats';
import { Unidad } from 'src/app/_models/unidad';
import { CsvDownloadService } from 'src/app/_services/csv-download.service';
import { ThrobberService } from 'src/app/_services/throbber.service';
import { MatDialog } from '@angular/material/dialog';
import { UnidadEventoClassroomMcpComponent } from '../../unidad-evento-classroom-mcp/unidad-evento-classroom-mcp.component';
import { ClassroomService } from 'src/app/_services/classroom.service';

@Component({
  selector: 'unidad-evento',
  standalone: false,
  templateUrl: 'unidad-evento.component.html',
  styleUrls: ['unidad-evento.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class UnidadEventoComponent implements OnInit, OnDestroy, OnChanges {

  @Input()
  eventoUnidad: EventoUnidad;

  @Input()
  set showResumenStatus(value: boolean) {
    this.showResumen = value;
  }

  @Input()
  isFamilia = false;
  @Input()
  alumnoId: number;

  @Input()
  unidad: Unidad;

  showResumen = false;

  materiasDisponibles: any = [];

  editarFecha = false;
  mcpEdicion = { id: 0, fechaAplicar: '', duracion: 0, fechaOriginal: '', idEventoUnidad: 0 };

  @Output()
  eliminar: EventEmitter<number> = new EventEmitter<number>();

  comentariosObservable;
  gapiPickerSubscriber: Subscription;

  working = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private estudioService: EstudioService,
    private unidadEtapasService: UnidadEtapasService,
    private retroalimentacionService: RetroalimentacionService,
    private snackBar: MatSnackBar,
    private comentariosService: ComentariosService,
    private customAlertService: CustomAlertService,
    private pickerService: GapiPickerService,
    private csvDownload: CsvDownloadService,
    private throbberService: ThrobberService,
    private classroomService: ClassroomService,
    private matDialogRef: MatDialog) {
    this.comentariosObservable = this.comentariosService.getComentariosObservable();
  }

  ngOnInit() {
    this.unidadEtapasService.getUnidadEtapasObservable().subscribe(data => {
      if (!data) {
        return false;
      }
      if (data.tipo == 'actualizar-materias-periodo') {
        this.materiasDisponibles = data.materias;
      }
      if (data.tipo == 'actualizar-fecha-evidencia-unidad' && data.objeto.unidadEventoID == this.eventoUnidad.id) {
        const indiceEventoMateria = this.eventoUnidad.eventoMaterias.findIndex(e => e.id == data.objeto.id);
        this.eventoUnidad.eventoMaterias[indiceEventoMateria].fechaAplicar = data.objeto.fechaAplicar;
        this.eventoUnidad.eventoMaterias[indiceEventoMateria].duracion = data.objeto.duracion;
      }
      if (data.tipo == 'actualizar-estado-evento-materia') {

      }
      if (data.tipo == 'eliminar-recurso-evento' && data.objeto.parentID == this.eventoUnidad.id) {
        const indiceRecurso = this.eventoUnidad.recursos.findIndex(rec => rec.id == data.objeto.recurso.id);
        if (indiceRecurso > -1) {
          this.eventoUnidad.recursos.splice(indiceRecurso, 1);
        }
      }
      if (data.tipo == 'actualizar-recurso-evento' && data.objeto.parentID == this.eventoUnidad.id) {
        const indiceRecurso = this.eventoUnidad.recursos.findIndex(rec => rec.id == data.objeto.recurso.id);
        this.eventoUnidad.recursos[indiceRecurso] = data.objeto.recurso;
      }
    });
    this.estudioService.getEstudioServiceObservable().subscribe(data => {
      if (!data) {
        return false;
      }
      if (data.tipo == 'actualizar-evento' && this.eventoUnidad.id == data.eventoUnidad.id) {
        this.eventoUnidad = data.eventoUnidad;
        this.estudioService.actualizarListaEventos(this.eventoUnidad);
      }
    });

    this.comentariosObservable.subscribe(data => {
      if (!data) {
        return;
      }
      if (data.accion == 'actualizar-cuenta' && data.tipo == 'unidadevento') {
        if (data.objetoID == this.eventoUnidad.id) {
          this.eventoUnidad.comentariosNuevos--;
        }
      }
    });

    this.gapiPickerSubscriber = this.pickerService.getPickerServiceObservable().subscribe(evt => {
      if (evt.tipo == 'agregarRecursos' && evt.targetTipo == 'unidadevento' && this.eventoUnidad.id == evt.parentID) {
        this.eventoUnidad.recursos = this.eventoUnidad.recursos.concat(evt.elementos);
      }
    });

    this.materiasDisponibles = this.unidadEtapasService.getMaterias();
    this.checkVideo();

    this.procesarMaterias();

    this.fechasValid();

  }

  ngOnDestroy() {
    // TODO: Incluir todos los servicios en subscription para unsubscribe.
    this.gapiPickerSubscriber.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    const showResumen: SimpleChange = changes.showResumenStatus;

    this.showResumen = showResumen.currentValue;
  }

  // ngAfterViewChecked(){
  //     // let gapi = this.pickerService.getGapi();
  //     // setTimeout(() => {
  //     //     gapi['sharetoclassroom'].go('g-sharetoclassroom');
  //     // }, 1500);
  // }

  checkVideo() {
    const re = /oembed/g;
    this.eventoUnidad.evento.resumen = this.eventoUnidad.evento.resumen.replace(re, 'iframe');
    this.eventoUnidad.evento.resumen = this.eventoUnidad.evento.resumen.replace(' url=', ' src=');
  }

  procesarMaterias() {
    this.eventoUnidad.eventoMaterias.map(eventoMateria => {
      const nombre = this.materiasDisponibles.find(mat => mat.id === eventoMateria.materiaCursoPeriodoID),
        str = nombre ? `${nombre.nickNombreCompleto}` : 'N/A';
      eventoMateria['nombre'] = str;
    });
  }

  setEstadoMCP(id, estado) {
    this.unidadEtapasService.setEstadoMCP(id, estado).subscribe(res => {
      const eventoMateria = this.eventoUnidad.eventoMaterias.find(evMat => evMat.id === id);
      eventoMateria.isCompletado = estado;
      this.unidadEtapasService.actualizarObjeto('evento-calendario-estado', eventoMateria);
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `Error al actualizar el evento. ${err.error} Codigo: ${err.statusText}`
      });
    });
  }

  editarMCP(mcp) {
    this.mcpEdicion = mcp;
    this.editarFecha = true;
    this.fechasValid();
  }

  guardarMCP(mcpEditado) {
    this.unidadEtapasService.guardarMCP(mcpEditado).subscribe(res => {
      const indiceEventoMateria = this.eventoUnidad.eventoMaterias.findIndex(el => el.id == this.mcpEdicion.id);
      this.eventoUnidad.eventoMaterias[indiceEventoMateria].fechaAplicar = this.mcpEdicion.fechaAplicar;
      this.eventoUnidad.eventoMaterias[indiceEventoMateria].duracion = this.mcpEdicion.duracion;
      this.unidadEtapasService.actualizarObjeto('evento-calendario-unidad', mcpEditado);
      this.editarFecha = false;
      this.mcpEdicion = { id: 0, fechaAplicar: '', duracion: 0, fechaOriginal: '', idEventoUnidad: 0 };
      this.fechasValid();
      this.snackBar.open(`El evento se ha actualizado satisfactoriamente.`, null, {
        duration: 3000
      });
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `Error al actualizar el evento. ${err.error} Codigo: ${err.statusText}`
      });
    });
  }

  editar(id) {
    this.unidadEtapasService.emitAbrirModal(id, 'evento-unidad');
  }

  borrar() {
    this.eliminar.emit(this.eventoUnidad.evento.id);
  }

  verRubrica() {
    this.unidadEtapasService.emitAbrirDialogo(this.eventoUnidad.id, 'rubrica_evento');
  }

  verComentarios() {
    this.unidadEtapasService.emitAbrirModal(this.eventoUnidad.id, 'comentarios_evento');
  }

  conectarEventoConMetas() {
    this.unidadEtapasService.emitAbrirModal(this.eventoUnidad.id, 'lista-metas-conectar');
  }

  duplicarEvento(eventoUnidadID, idCategoria) {
    this.working = true;
    this.estudioService.duplicarEventoUnidad(eventoUnidadID, idCategoria).subscribe(res => {
      const eventoDuplicado = new EventoUnidad(this.estudioService.extractData(res));
      this.unidadEtapasService.agregarObjeto('evento-unidad', eventoDuplicado);
      this.working = false;
    }, err => {
      this.working = false;
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible duplicar el evento. <br> Código de error: ${err.statusText}`
      });
    });
  }

  estadoRecursoEstudiantes(recurso) {
    recurso.isVisibleToStudent = !recurso.isVisibleToStudent;
    this.unidadEtapasService.actualizarRecurso(recurso).subscribe(res => {
      const objeto = { targetID: this.eventoUnidad.id, recurso };
      this.unidadEtapasService.actualizarObjeto('recurso-evento', objeto);
      this.snackBar.open(`El recurso ${recurso.nombre} ha sido actualizado correctamente.`,
        null,
        { duration: 2500 });
    }, err => {
      recurso.isVisibleToStudent = !recurso.isVisibleToStudent;
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible eliminar el recurso. <br> Código de error: ${err.statusText}`
      });
    });
  }

  retroalimentar(materiaID = 0) {
    // NavegaRetroalimentar
    let routeOutletParams = ['estudio', 'unidad', this.unidad.id, 'retroalimentacion', 'evento', this.eventoUnidad.id];
    if (materiaID !== 0) {
      routeOutletParams = ['estudio', 'unidad', this.unidad.id, 'retroalimentacion', 'evento', this.eventoUnidad.id, 'materia', materiaID];
    }
    this.router.navigate(routeOutletParams);
  }

  generatePdf(eventoMateriaId: number) {
    this.retroalimentacionService.pdfRetroalimentacion(
      { eventoMateriaId: eventoMateriaId }
      // { eventoID: this.eventoUnidad.id, isRubrica: true, isComentario: true }
      ).subscribe(res => {
        const fileURL = URL.createObjectURL(res);
        window.open(fileURL, '_blank');
      });
  }

  generarCsv() {
    this.throbberService.setThrobberState(true);
    this.unidadEtapasService.getRubricaEvento(this.eventoUnidad.id).subscribe(rubrica => {
      const result = [];
      if (this.eventoUnidad.evento.nombre) {
        result.push([this.encomillar(this.eventoUnidad.evento.nombre)]);
      } else {
        result.push(['']);
      }
      result.push(['v1.0-f']);
      rubrica.forEach(meta => {
        meta.criterios.forEach(criterio => {
          criterio.niveles.forEach(nivel => {
            if (criterio.nombre) {
              result.push([this.encomillar(criterio.nombre)]);
            } else {
              result.push('');
            }
            if (nivel.nombre) {
              result.push([this.encomillar(nivel.nombre)]);
            } else {
              result.push('');
            }
            result.push(['', 'Logro destacado', 'Logro' , 'Logro parcial', 'No logro', 'Pendiente']);
            const line: string[] = [''];
            nivel.criterios.sort((a, b) => a.orden > b.orden).forEach(logro => {
              if (logro.nombre) {
                line.push(this.encomillar(logro.nombre));
              } else {
                line.push('');
              }
            });
            line.push('Pendiente');
            result.push(line);
          });
        });
      });
      // this.csvDownload.downloadFile(csv, `Rubrica-${this.eventoUnidad.evento.nombre}-${this.eventoUnidad.id}.csv`);
      this.crearSheet(result);
    },
    err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `Error al traer la rubrica. <br> Código de error: ${err.statusText}`
      });
    });
  }

  crearSheet(data: any[]) {
    this.pickerService.loadGapi();
    this.pickerService.onLoad$.subscribe(res => {
      this.pickerService.retornarSpreadsheet(
        `Rubrica-${this.eventoUnidad.evento.nombre}-${this.eventoUnidad.id}`, ['rubrica']).then(response => {
        const hoja = response.result.sheets[0].properties.title;
        this.pickerService.appendValue(response.result.spreadsheetId, hoja, {
          values: data
        }).then(() => {
          this.throbberService.setThrobberState(false);
          window.open(response.result.spreadsheetUrl, '_blank');
        }).catch(function(e) {
          this.customAlertService.setCustomMessage({
            tipo: 'error',
            texto: `Error al comunicarse con google. <br> Código de error: ${e.statusText}`
          });
        });
      }).catch(function(e) {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `Error al comunicarse con google. <br> Código de error: ${e.statusText}`
        });
      });
    });
  }

  encomillar(param) {
    return param.replace(/(\r\n|\n|\r)/gm, '');
  }

  editarEvento(eventoMateria) {
    if (eventoMateria.courseId) {
      this.classroomService.getClassroomCourswork(eventoMateria.courseId).subscribe(res => {
        this.matDialogRef.open(UnidadEventoClassroomMcpComponent, {
          disableClose: true,
          data: {
            eventoMateria,
            tareas: res
          }
        });
      })
    } else {
      this.matDialogRef.open(UnidadEventoClassroomMcpComponent, {
        disableClose: true,
        data: {
          eventoMateria,
          tareas: []
        }
      });
    }
  }

  verRetroalimentacion() {
    this.router.navigate([{ outlets: { retroalimentacionalumno: ['evento', this.eventoUnidad.id] } }], { relativeTo: this.route });
  }

  fechasValid() {
    this.eventoUnidad.eventoMaterias.forEach(evento => {
      evento.fechaValid = this.fechaAplicarValid(evento.fechaAplicar);
    });
  }

  fechaAplicarValid(fechaInput: string) {
    const fecha = moment(fechaInput, 'YYYY-MM-DD');
    if (fecha) {
      return fecha < moment(this.unidad.fechaInicia, 'YYYY-MM-DD') || fecha > moment(this.unidad.fechaFin, 'YYYY-MM-DD');
    } else {
      return false;
    }
  }

  setElementVisibilityStatus(element, status) {
    element.style.visibility = status;
  }
}
